import axios from 'axios';
import {API_URL} from 'config';
import mem from 'mem';
import {TokenResult} from 'types';
import {authUtil} from 'utils/auth';

const refreshTokenFn = async (): Promise<TokenResult | undefined> => {
  const refreshToken = authUtil.getRefreshToken();

  try {
    if (!refreshToken) {
      authUtil.clear();
      return;
    }

    const response = await axios.post<any, any>(
      '/token/refresh/',
      {
        refresh: refreshToken,
      },
      {
        baseURL: API_URL,
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
      },
    );

    if (response.data.access) {
      authUtil.login(response.data);
    }

    return response.data;
  } catch (error) {
    authUtil.logout();
  }
};

export const memoizedRefreshTokenFn = mem(refreshTokenFn, {
  maxAge: 10000,
});
